export const ROUTE_HOME = '/';
export const ROUTE_DETAILS = '/details';
export const ROUTE_OVERVIEW = '/overview';
export const ROUTE_REWARDS= '/rewards';
export const ROUTE_STAKING = '/stake';
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_LAUNCHPADS = '/launchpads';
export const ROUTE_INVESTMENTS = '/investments';

